import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedStethoscopeIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.50488 1.5C9.78103 1.5 10.0049 1.72386 10.0049 2V3.40039C10.0047 3.67635 9.78089 3.90039 9.50488 3.90039H7.49512C7.12701 3.90044 6.81344 4.24016 6.86719 4.65625L7.98633 11.8916L7.9873 11.9033C8.15171 13.1719 9.19853 14.0995 10.4141 14.0996H13.5859C14.8015 14.0995 15.8483 13.1719 16.0127 11.9033L16.0137 11.8916L17.1328 4.65625C17.1866 4.24016 16.873 3.90044 16.5049 3.90039H14.4951C14.2191 3.90039 13.9953 3.67635 13.9951 3.40039V2C13.9951 1.72386 14.219 1.5 14.4951 1.5H16.5049C18.3311 1.50005 19.7095 3.14811 19.4736 4.96973L19.4717 4.98242L18.3516 12.2285L18.3506 12.2275C18.0297 14.6629 16.0041 16.4999 13.5859 16.5H10.4141C7.99581 16.4999 5.96929 14.663 5.64844 12.2275V12.2285L4.52832 4.98242L4.52637 4.96973C4.29053 3.14811 5.66889 1.50005 7.49512 1.5H9.50488Z",
			fill: "white",
			stroke: "#1F3B44",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.001 14.335C12.6444 14.335 13.166 14.8566 13.166 15.5V19.5C13.1661 19.9611 13.5398 20.335 14.001 20.335H18.501C19.1444 20.335 19.666 20.8566 19.666 21.5C19.666 22.1434 19.1443 22.665 18.501 22.665H14.001C12.253 22.665 10.836 21.2479 10.8359 19.5V15.5C10.8359 14.8566 11.3576 14.335 12.001 14.335Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.5,
			cy: 21.5,
			r: 1.5,
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-4-outside-1_22382_133765",
			maskUnits: "userSpaceOnUse",
			x: 3.98047,
			y: 10.1016,
			width: 16,
			height: 7,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 3.98047,
				y: 10.1016,
				width: 16,
				height: 7
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.8572 12.1526L18.0197 11.1016H16.6422L16.5083 11.9676C16.313 13.4745 15.0635 14.6 13.5858 14.6H10.4144C8.93664 14.6 7.68716 13.4745 7.49185 11.9676L7.35794 11.1016H5.98047L6.143 12.1526C6.42844 14.3551 8.2546 16 10.4144 16H13.5858C15.7456 16 17.5717 14.3551 17.8572 12.1526Z"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.8572 12.1526L18.0197 11.1016H16.6422L16.5083 11.9676C16.313 13.4745 15.0635 14.6 13.5858 14.6H10.4144C8.93664 14.6 7.68716 13.4745 7.49185 11.9676L7.35794 11.1016H5.98047L6.143 12.1526C6.42844 14.3551 8.2546 16 10.4144 16H13.5858C15.7456 16 17.5717 14.3551 17.8572 12.1526Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0197 11.1016L19.008 11.2544L19.1862 10.1016H18.0197V11.1016ZM17.8572 12.1526L16.8689 11.9998L16.8671 12.0119L16.8655 12.0241L17.8572 12.1526ZM16.6422 11.1016V10.1016H15.785L15.654 10.9487L16.6422 11.1016ZM16.5083 11.9676L15.5201 11.8147L15.5182 11.8269L15.5166 11.839L16.5083 11.9676ZM7.49185 11.9676L8.48356 11.839L8.48198 11.8269L8.48011 11.8147L7.49185 11.9676ZM7.35794 11.1016L8.34619 10.9487L8.21519 10.1016H7.35794V11.1016ZM5.98047 11.1016V10.1016H4.81395L4.99221 11.2544L5.98047 11.1016ZM6.143 12.1526L7.1347 12.0241L7.13313 12.0119L7.13125 11.9998L6.143 12.1526ZM17.0315 10.9487L16.8689 11.9998L18.8454 12.3054L19.008 11.2544L17.0315 10.9487ZM16.6422 12.1016H18.0197V10.1016H16.6422V12.1016ZM17.4966 12.1204L17.6305 11.2544L15.654 10.9487L15.5201 11.8147L17.4966 12.1204ZM13.5858 15.6C15.5878 15.6 17.243 14.0798 17.5 12.0961L15.5166 11.839C15.3831 12.8693 14.5393 13.6 13.5858 13.6V15.6ZM10.4144 15.6H13.5858V13.6H10.4144V15.6ZM6.50015 12.0961C6.75723 14.0798 8.41241 15.6 10.4144 15.6V13.6C9.46086 13.6 8.61708 12.8693 8.48356 11.839L6.50015 12.0961ZM6.36968 11.2544L6.5036 12.1204L8.48011 11.8147L8.34619 10.9487L6.36968 11.2544ZM5.98047 12.1016H7.35794V10.1016H5.98047V12.1016ZM7.13125 11.9998L6.96872 10.9487L4.99221 11.2544L5.15474 12.3054L7.13125 11.9998ZM10.4144 15C8.77882 15 7.35837 13.7499 7.1347 12.0241L5.15129 12.2811C5.49851 14.9603 7.73038 17 10.4144 17V15ZM13.5858 15H10.4144V17H13.5858V15ZM16.8655 12.0241C16.6418 13.7499 15.2214 15 13.5858 15V17C16.2698 17 18.5017 14.9603 18.8489 12.2811L16.8655 12.0241Z",
			fill: "#1F3B44",
			mask: "url(#path-4-outside-1_22382_133765)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.5,
			cy: 2.5,
			r: 1.5,
			fill: "#4B7987",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.5,
			cy: 2.5,
			r: 1.5,
			fill: "#4B7987",
			stroke: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedStethoscopeIcon);
const Memo = memo(ForwardRef);
export default Memo;
